import graphqlClient from './client';
import gql from 'graphql-tag';
import type { SearchJobApplicationSummary } from './types';
import type { ProspectsWithPaginationByPositionIdProps } from './utils';

export const query = gql`
  query JobApplicationSummariesByPositionId(
    $positionId: ID!
    $advertiserId: ID!
    $searchText: String
    $bucket: Bucket
    $sort: Sort
    $sortOrder: SortOrder
    $filters: ProspectFilters
  ) {
    jobApplicationSummariesByPositionId(
      input: {
        positionId: $positionId
        advertiserId: $advertiserId
        searchText: $searchText
        bucket: $bucket
        sort: $sort
        sortOrder: $sortOrder
        filters: $filters
      }
    ) {
      nodes {
        applicationCorrelationId
        adcentreProspectId
        candidateFirstname
        candidateLastname
        status {
          text
        }
      }
    }
  }
`;
export interface JobApplicationSummaryResult {
  nodes: SearchJobApplicationSummary[];
}
const fetchJobApplicationSummariesByPositionId = async (
  variables: ProspectsWithPaginationByPositionIdProps,
): Promise<JobApplicationSummaryResult> => {
  const result = await graphqlClient.query({
    variables,
    query,
  });

  const prospectsResult = result.data.jobApplicationSummariesByPositionId;

  return prospectsResult;
};

export default fetchJobApplicationSummariesByPositionId;
